/** Deep-merge overlay into base (objects only; arrays replace). */
export function mergeTranslation<T extends Record<string, unknown>>(
  base: T,
  overlay: Record<string, unknown>,
): T {
  const out: Record<string, unknown> = { ...base };

  for (const [key, value] of Object.entries(overlay)) {
    const existing = out[key];
    if (
      value &&
      typeof value === 'object' &&
      !Array.isArray(value) &&
      existing &&
      typeof existing === 'object' &&
      !Array.isArray(existing)
    ) {
      out[key] = mergeTranslation(
        existing as Record<string, unknown>,
        value as Record<string, unknown>,
      );
    } else {
      out[key] = value;
    }
  }

  return out as T;
}
